import { inject } from '@angular/core';
import { Router, type CanActivateFn, type UrlTree } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { type Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { userHasEFilingAccess } from './e-filing.guard';
import { userHasQuoteLogAccess } from './quote-log.guard';
import { resolveActiveAccount } from './active-account';

// Resolves the home route per user: E-Filing for process-group members,
// Quote Log for quote-log-group members, otherwise the no-access page.
// Waits for MSAL to finish any in-progress interaction (e.g. redirect login)
// so the account/claims are populated before the routing decision is made.
export const homeRedirectGuard: CanActivateFn = (): Observable<UrlTree> => {
	const msalService = inject(MsalService);
	const broadcastService = inject(MsalBroadcastService);
	const router = inject(Router);

	return broadcastService.inProgress$.pipe(
		filter((status) => status === InteractionStatus.None),
		take(1),
		map(() => {
			const account = resolveActiveAccount(msalService);

			if (userHasEFilingAccess(account)) {
				return router.createUrlTree(['/e-filing']);
			}

			if (userHasQuoteLogAccess(account)) {
				return router.createUrlTree(['/quote-log']);
			}

			return router.createUrlTree(['/no-access']);
		})
	);
};
